<script setup>

import {APP_NAME} from "@/globals/contants";
import {ref} from "vue";

// Lista de sponsors con URLs o rutas a tus imágenes
const sponsors = ref([
  { name: "Amigos Truck Parts INC", logo: "1.svg" },
  { name: "Cyber Lab LLC", logo: "2.svg" },
  { name: "Dhomes", logo: "3.svg" },
  { name : "Ama Quality Home LLC", logo : "4.svg"},
  { name : "Marzucco Real State", logo : "5.jpg"},
  // Puedes añadir más sponsors aquí
]);

</script>

<template>
  <div class="text-electride-light max-w-7xl m-auto">
    <!-- Header -->
    <header class="rounded-lg text-center py-10 shadow-lg dark:bg-gray-900 bg-white text-gray:-800 dark:text-gray-400">
      <h1 class="text-5xl font-bold">Welcome to {{APP_NAME}}</h1>
      <p class="text-2xl mt-2">Your Premier Airport Ride Solution</p>
    </header>

    <!-- Main Content -->
    <main class="py-10 px-6">
      <!-- The Concept Behind ElectRide -->
      <div class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">The Concept Behind {{APP_NAME}}</h2>
        <p class="text-gray-700 leading-relaxed dark:text-gray-300">
          <img src="/images/electride_app-icon.svg" alt="{{APP_NAME}}" class="w-24 float-right ml-4 mb-4" />
          At <strong>{{APP_NAME}}</strong>, we are redefining the way travelers experience ground transportation. Designed with
          convenience, efficiency, and sustainability in mind, {{APP_NAME}} connects passengers with reliable rides from airports
          to their destinations. Whether you're a business traveler, a vacationer, or someone in need of a seamless ride experience,
          {{APP_NAME}} ensures your journey starts and ends with comfort.
          At {{APP_NAME}}, we are redefining the way travelers experience ground transportation. Designed with convenience, efficiency, and sustainability in mind, {{APP_NAME}} connects passengers with reliable rides from airports to their destinations. Whether you're a business traveler, a vacationer, or someone in need of a seamless ride experience, ElectRide ensures your journey starts and ends with comfort.
          <br>
          <br>
          Developed by <strong>Cyber Lab Hardware and Software Services LLC</strong>, a company dedicated to software development
          and the creation and sale of hardware, delivering innovative and efficient solutions for modern transportation needs.
        </p>
      </div>

      <!-- Key Features -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold  dark:text-emerald-300 text-emerald-900 mb-4">Key Features of {{APP_NAME}}</h2>
        <ul class="list-disc list-inside text-gray-700 dark:text-gray-300 leading-relaxed space-y-2">
          <li><strong>Real-Time Availability:</strong> Book rides instantly or schedule them in advance, ensuring you're always covered.</li>
          <li><strong>Easy-to-Use Interface:</strong> Navigate the app effortlessly with a clean design and user-friendly features.</li>
          <li><strong>Transparent Pricing:</strong> Enjoy upfront pricing with no hidden fees or surprises.</li>
          <li><strong>Reliable Drivers:</strong> Experience professional service from vetted drivers committed to safety and quality.</li>
          <li><strong>Diverse Vehicle Options:</strong> Choose from a range of vehicles to suit your needs, from solo travel to group trips.</li>
          <li><strong>Eco-Friendly Commitment:</strong> Opt for electric and hybrid vehicles for a sustainable travel choice.</li>
        </ul>
      </section>

      <!-- Why ElectRide for Airport Travel -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">Why {{APP_NAME}} for Airport Travel?</h2>
        <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
          Airports are bustling hubs, often making it challenging to find reliable transportation. {{APP_NAME}} specializes in
          airport rides, integrating real-time flight data to ensure drivers are aware of your arrival and departure times. This
          synchronization minimizes waiting times and enhances convenience, especially for travelers with luggage or tight
          schedules.
        </p>
      </section>

      <!-- Safety and Security -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">Safety and Security</h2>
        <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
          Your safety is our top priority. From GPS tracking and driver identification to the ability to share trip details with
          loved ones, {{APP_NAME}} employs robust safety measures for every ride.
        </p>
      </section>

      <!-- How ElectRide Benefits Drivers -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900mb-4">How {{APP_NAME}} Benefits Drivers</h2>
        <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
          {{APP_NAME}} is also a platform for drivers seeking flexible work opportunities. Enjoy competitive earnings, dynamic
          scheduling, and a supportive community that values excellence.
        </p>
      </section>

      <!-- Vision for the Future -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">Vision for the Future</h2>
        <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
          {{APP_NAME}} is more than an app; it’s a movement toward smarter, more sustainable travel. Our vision includes expanding
          to more airports, integrating advanced technologies like AI-driven route optimization, and adding EV-friendly charging
          stations for a better user experience.
        </p>
      </section>

      <!-- Join the ElectRide Revolution -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">Join the {{APP_NAME}} Revolution</h2>
        <p class="text-gray-700 dark:text-gray-300 leading-relaxed">
          Travel is meant to be enjoyable and enriching, and {{APP_NAME}} is here to ensure every journey begins and ends on the
          right note. Download {{APP_NAME}} today and experience the future of airport transportation. Wherever your journey takes
          you, {{APP_NAME}} is your trusted partner on the road.
        </p>
      </section>

      <!-- Sponsors -->
      <section class="my-10 bg-white dark:bg-gray-700 p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold dark:text-emerald-300 text-emerald-900 mb-4">Sponsors</h2>
        <div class="text-gray-700 dark:text-gray-300 leading-relaxed grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div class="text-center bg-gray-100 dark:bg-gray-800 rounded-lg py-3" v-for="sponsor in sponsors" :key="sponsor.name">
            <img :src="`/images/sponsor/${sponsor.logo}`" alt="Dhomes" class="w-24 mb-1 mx-auto" />
            <strong>{{sponsor.name}}</strong>
          </div>
        </div>
      </section>

    </main>

  </div>

</template>

<style scoped>

</style>